import { GiftType } from "src/models/gift/GiftType"

export const GIFT_TYPE_DEFINITIONS: GiftType[] = [
  {
    id: 1,
    name: "100TG",
    iconUrl: "/img/gift/gift_100.png",
    amount: 100,
    price: 110,
  },
  {
    id: 2,
    name: "500TG",
    iconUrl: "/img/gift/gift_500.png",
    amount: 500,
    price: 550,
  },
  {
    id: 3,
    name: "1000TG",
    iconUrl: "/img/gift/gift_1000.png",
    amount: 1000,
    price: 1100,
  },
  {
    id: 4,
    name: "2000TG",
    iconUrl: "/img/gift/gift_2000.png",
    amount: 2000,
    price: 2200,
  },
  {
    id: 5,
    name: "5000TG",
    iconUrl: "/img/gift/gift_5000.png",
    amount: 5000,
    price: 5500,
  },
  {
    id: 6,
    name: "10000TG",
    iconUrl: "/img/gift/gift_10000.png",
    amount: 10000,
    price: 11000,
  },
]
